import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime } from 'helpers/dateTimeFormatter';

const ScatterTooltip = ({ point, xUnit, yUnit, xName, yName }) => {
    return <div className='scatter-tooltip'>
        <div className='scatter-tooltip-header'>{formatDateTime(point.date)}</div>
        {xName}: {point.x} {xUnit}<br />
        {yName}: {point.y} {yUnit}<br /></div>;
};


ScatterTooltip.propTypes = {
    point: PropTypes.object,
    name: PropTypes.string,
    xUnit: PropTypes.string,
    yUnit: PropTypes.string,
    xName: PropTypes.string,
    yName: PropTypes.string
};

export default ScatterTooltip;
